module.exports = __webpack_public_path__ + "img/l_d6.689375bf.png";